(() => {
  const pageKey = 'moomzee:lastShoppingPage';
  const restoreKey = 'moomzee:restoreShoppingScroll';
  const fallback = '/collections/all';

  function sameOriginUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch (_) {
      return null;
    }
  }

  function cleanPath(url) {
    return url.pathname + url.search;
  }

  function isCartLike(path) {
    return path === '/cart' || path.startsWith('/checkout') || path.startsWith('/checkouts');
  }

  function isShoppingPage(path) {
    return path === '/' || path.startsWith('/products/') || path.startsWith('/collections/') || path.startsWith('/search');
  }

  function getSavedPage() {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(pageKey) || window.localStorage.getItem(pageKey) || 'null');
      if (!saved || !saved.url) return null;
      const url = sameOriginUrl(saved.url);
      if (!url || isCartLike(url.pathname)) return null;
      return { url: cleanPath(url), scrollY: Number(saved.scrollY || 0) };
    } catch (_) {
      return null;
    }
  }

  function saveCurrentPage() {
    if (!isShoppingPage(window.location.pathname) || isCartLike(window.location.pathname)) return;
    const data = JSON.stringify({ url: cleanPath(window.location), scrollY: Math.max(0, Math.round(window.scrollY || 0)) });
    try {
      window.sessionStorage.setItem(pageKey, data);
      window.localStorage.setItem(pageKey, data);
    } catch (_) {}
  }

  function updateContinueLinks() {
    const saved = getSavedPage();
    const href = saved?.url || fallback;
    document.querySelectorAll('[data-mz-continue-shopping]').forEach((link) => {
      link.setAttribute('href', href);
      link.addEventListener('click', () => {
        try { window.sessionStorage.setItem(restoreKey, '1'); } catch (_) {}
      }, { once: true });
    });
  }

  let scrollTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(saveCurrentPage, 160);
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a, button, input[type="submit"]');
    if (!target) return;
    const text = (target.textContent || target.value || '').toLowerCase();
    const href = target.getAttribute?.('href') || '';
    if (text.includes('add to cart') || href.includes('/cart') || target.closest('form[action*="/cart/add"]')) {
      saveCurrentPage();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    const saved = getSavedPage();
    const shouldRestore = (() => {
      try { return window.sessionStorage.getItem(restoreKey) === '1'; } catch (_) { return false; }
    })();
    if (shouldRestore && saved && saved.url === cleanPath(window.location)) {
      try { window.sessionStorage.removeItem(restoreKey); } catch (_) {}
      requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY || 0, behavior: 'auto' }));
    }
    if (!isCartLike(window.location.pathname)) saveCurrentPage();
    updateContinueLinks();
  });

  document.addEventListener('shopify:section:load', updateContinueLinks);
  document.addEventListener('cart:updated', updateContinueLinks);
  const observer = new MutationObserver(updateContinueLinks);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();